<template>
  <a-modal
    :title="model.id ? '编辑成员' : '新增成员'"
    okText="确定"
    :width="700"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :bodyStyle="bodyStyle"
    @ok="onSubmit"
    @cancel="handleCancel"
  >
    <!-- form-model -->
    <a-form-model
      ref="ruleForm"
      :model="model"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <!-- 合拍ID -->
      <a-form-model-item
        label="合拍ID"
        prop="hepaiID"
        :rules="{ required: true, message: '请选择合拍ID', trigger: 'blur' }"
      >
        <!-- 编辑模式时，合拍ID不允许编辑 -->
        <a-select
          show-search
          placeholder="请输入"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          :not-found-content="null"
          :disabled="confirmLoading || !!model.id"
          v-model="model.hepaiID"
          @search="handleSearch"
        >
          <a-select-option
            v-for="item in userList"
            :key="item.id"
            :value="item.id"
          >
            {{ item.id }}（{{ item.nickname }}）
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 姓名 -->
      <a-form-model-item
        label="姓名"
        prop="username"
        :rules="{ required: true, message: '请填写姓名', trigger: 'blur' }"
      >
        <a-input v-model.trim="model.username" :maxLength="20" />
      </a-form-model-item>
      <!-- 部门 -->
      <a-form-model-item
        label="部门"
        prop="deptIds"
        :rules="{ required: true, message: '请选择部门', trigger: 'blur' }"
      >
        <a-select v-model="model.deptIds" :getPopupContainer="getPopupContainer">
          <a-select-option v-for="item in deptList" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!-- 角色 -->
      <a-form-model-item
        label="角色"
        prop="roleIds"
        :rules="{ required: true, message: '请选择角色', trigger: 'blur' }"
      >
        <a-select mode="multiple" v-model="model.roleIds" :getPopupContainer="getPopupContainer">
          <a-select-option v-for="item in roleList" :key="item.id" :value="item.id">
            {{ item.show_name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import Pub from '@/utils/public'
import { getAllRoleList, getAllDepteList, getHepaiUserList, editMember, getMemberDetail } from '@/api/request'
export default {
  data () {
    return {
      // 显示/加载
      visible: false,
      confirmLoading: false,
      // 样式
      bodyStyle: {
        padding: '16px 24px'
      },
      // 水平布局，保持一行
      span: 12,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      // 上传数据
      model: {},
      // 合拍用户列表
      userList: [],
      // 部门列表
      deptList: [],
      // 角色列表
      roleList: []
    }
  },
  created () {
    this.initModel()
  },
  methods: {
    // 初始化数据 model
    initModel () {
      this.model = {
        username: undefined,
        // 成员id
        id: undefined,
        // 合拍id
        hepaiID: undefined,
        deptIds: undefined,
        roleIds: undefined
      }
    },
    // 显示
    showModal (record) {
      // 显示
      this.visible = true
      // 获取全部角色列表（不分页）
      this.getAllRoleList()
       // 获取全部部门列表（不分页）
      this.getAllDepteList()
      // 编辑时
      if (record && record.id) {
        this.model.id = record.id
        // 获取部门详情
        this.getMemberDetail()
      }
    },
    // 隐藏
    handleCancel () {
      if (!this.confirmLoading) {
        // 重置
        this.$refs['ruleForm'].resetFields()
        // 初始化数据
        this.initModel()
        this.visible = false
      }
    },
    // 重新指定渲染控件
    getPopupContainer (triggerNode) {
      return triggerNode.parentNode
    },
    // 获取成员详情
    getMemberDetail () {
      this.confirmLoading = true
      getMemberDetail({
        id: this.model.id
      }).then(res => {
        this.confirmLoading = false
        const { code, data, msg } = res
        if (code === 0) {
          // 设置数据
          this.model = Object.assign({}, this.model, {
            hepaiID: data.user_id,
            username: data.username,
            deptIds: data.dept.length ? data.dept[0].id : undefined,
            roleIds: data.role.map(item => item.id)
          })
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 搜索用户，节流
    handleSearch: Pub.THROTTLING(function (value) {
      if (!value) return
      const params = {
        search: value
      }
      // 获取合拍用户列表
      getHepaiUserList(params).then(res => {
        const { code, data } = res
        if (code === 0 && data.data.length) {
          this.userList = data.data
        } else {
          this.userList = []
        }
      }).catch(() => {
        this.userList = []
      })
    }, 500),
    // 获取全部角色列表（不分页）
    getAllRoleList () {
      this.confirmLoading = true
      getAllRoleList().then(res => {
        this.confirmLoading = false
        const { code, data, msg } = res
        if (code === 0) {
          this.roleList = data.list
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 获取全部部门列表（不分页）
    getAllDepteList () {
      this.confirmLoading = true
      getAllDepteList().then(res => {
        this.confirmLoading = false
        const { code, data, msg } = res
        if (code === 0) {
          this.deptList = data.list
        } else {
          this.$message.error(msg)
        }
      })
    },
    // 提交
    onSubmit () {
      this.$refs['ruleForm'].validate((valid) => {
        // 效验成功
        if (valid) {
          this.confirmLoading = true
          const { id, username, deptIds, roleIds, hepaiID } = this.model
          const params = {
            id,
            username,
            hepai_id: hepaiID,
            dept_ids: [deptIds],
            role_ids: roleIds
          }
          editMember(params).then(res => {
            this.confirmLoading = false
            const { code, data, msg, message } = res
            if (code === 0) {
              this.$message.success('操作成功')
              this.handleCancel()
              this.$emit('success')
            } else {
              this.$message.error(msg || message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>